export const manageSiteFormAreas = `
		"siteIdContainer vendor"
		"coords coords"
		"siteType siteType"
		"submitButtons submitButtons"
		`;

export const coordsAreas = `
		"lat lng"
		"warning warning"
		`;

export const generateSiteIdTooltip = 'Click to generate next Site_ID';
export const vendorTooltip = 'To change Vendor, please remove existing technologies';
export const linkedSiteVendorTooltip = 'To change Vendor, please unlink the site from the asset';
export const createSiteCoordsWarningMessage = 'Sites without location data won’t be shown on the map.';
